/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.getRecords'

export { $nsid }

/** Get details about some records. */
const main = l.query(
  $nsid,
  l.params({
    uris: l.array(l.string({ format: 'at-uri' }), { maxLength: 100 }),
  }),
  l.jsonPayload({
    records: l.array(
      l.typedUnion(
        [
          l.typedRef<ModerationDefs.RecordViewDetail>(
            (() => ModerationDefs.recordViewDetail) as any,
          ),
          l.typedRef<ModerationDefs.RecordViewNotFound>(
            (() => ModerationDefs.recordViewNotFound) as any,
          ),
        ],
        false,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
